<div style="height:100%;">
	<div class="schema-table">
		<app-common-datagrid
			#schemaTable
			[columns]="columns_schema"
			[rows]="rows_schema"
			[selectedRows]="selectedRows_schema"
			[hidePaging]="true"
			[isPaging]="false"
			(select)="onSelectData_schema($event)"
		></app-common-datagrid>
	</div>

</div>

<ng-template #cellTempl let-row="row" let-column="column" let-value="value">
	<div [title]="value || ''">
		<div [ngClass]="{'grey-cell': row[column.prop] === null}">{{row[column.prop] === null ? "null": value}}</div>
	</div>
</ng-template>
<ng-template #schemaTooltipTempl let-row="row" let-value="value">
	<div [title]="row.gss_desc">{{value}}</div>
</ng-template>
<ng-template #schemaErrorTempl let-row="row" let-column="column" let-value="value">
	<div *ngIf="row[schemaQcColName] && row[schemaQcColName].length" [title]="row[tooltipCol]" style="text-align:center;">
		<i class="glyphicons glyphicons-remove"></i>
	</div>
	<div *ngIf="row[schemaQcColName] && !row[schemaQcColName].length" title="No Error" style="text-align:center;">
		<i class="glyphicons glyphicons-ok"></i>
	</div>
	<!-- IF: error check is not requested, leave the cell empty -->
	<div *ngIf="!row[schemaQcColName]">
	</div>
</ng-template>